/* RESPONSIBLE TEAM: team-reporting */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { get } from 'embercom/lib/ajax';

export default class ExternalSharedLinksRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: any;

  get titleToken() {
    return this.intl.t('reporting.manage-external-shared-links.title');
  }

  async model() {
    // Fetch external shared links from the API using the standard ajax helper
    try {
      let sharedLinks = await get('/ember/reporting/report_snapshots/', {
        app_id: this.appService.app.id,
      });
      return { sharedLinks };
    } catch (error) {
      return { sharedLinks: [] };
    }
  }
}
